export const footerConstants = {
  SUBSCRIBE_NEWSLETTER_REQUEST: 'FOOTER_SUBSCRIBE_NEWSLETTER_REQUEST',
  SUBSCRIBE_NEWSLETTER_SUCCESS: 'FOOTER_SUBSCRIBE_NEWSLETTER_SUCCESS',
  SUBSCRIBE_NEWSLETTER_FAILURE: 'FOOTER_SUBSCRIBE_NEWSLETTER_FAILURE',
}
